import { render, staticRenderFns } from "./events.vue?vue&type=template&id=b434c824&scoped=true"
import script from "./js/event.js?vue&type=script&lang=js&external"
export * from "./js/event.js?vue&type=script&lang=js&external"
import style0 from "./events.vue?vue&type=style&index=0&id=b434c824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.29._9691e8a1bbcd57691b862420a6e71e49/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b434c824",
  null
  
)

export default component.exports